export default __webpack_public_path__ + "static/media/gitbook.3e71eae3.png";